import { Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'app-card-balance-transaction',
  templateUrl: './card-balance-transaction.component.html',
  styleUrl: './card-balance-transaction.component.scss'
})
export class CardBalanceTransactionComponent {
  dataSource: any;

  constructor(private environmentService: EnvironmentService) {

  }

  ngOnInit() {
    this.dataSource = new DataSource({
      store: new ODataStore({
        url:  this.environmentService.getConfig('BackendApi') + "odata/CardBalanceUpdateTransactions?$expand=Card($expand=Merchant)",
        key: "Id"
      })
    });
  }
}
